import { useEffect } from "react";
import { Header } from "@/components/aklive/Header";
import { Footer } from "@/components/aklive/Footer";
import { HomeHero } from "@/components/aklive/home/HomeHero";
import { Positioning } from "@/components/aklive/home/Positioning";
import { ServicesPreview } from "@/components/aklive/home/ServicesPreview";
import { FeaturedWork } from "@/components/aklive/home/FeaturedWork";
import { WhyAklive } from "@/components/aklive/home/WhyAklive";
import { IndustriesStrip } from "@/components/aklive/home/IndustriesStrip";
import { HomeCTA } from "@/components/aklive/home/HomeCTA";

export default function Home() {
  useEffect(() => {
    document.title = "AKLIVE — Built for what comes next";
  }, []);

  return (
    <div className="bg-paper text-left text-ink">
      <Header />
      <main id="main" className="overflow-x-clip">
        <HomeHero />
        <Positioning />
        <ServicesPreview />
        <FeaturedWork />
        <WhyAklive />
        <IndustriesStrip />
        <HomeCTA />
      </main>
      <Footer />
    </div>
  );
}
